// cart-uid.js: Adds UID to cart attributes
function getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
}

function addUidToCart() {
    const uid = getCookie('shopify_uid');
    if (uid) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: {
                    UID: uid,
                },
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('Cart updated with UID:', data);
            })
            .catch((error) => {
                console.error('Error updating cart with UID:', error);
            });
    }
}

document.addEventListener('DOMContentLoaded', addUidToCart);
